import {useUiLayoutStore} from '@frontend/stores'
import type {ReactNode} from 'react'

type Renderer = (() => ReactNode) | ReactNode

interface Props {
    desktop: Renderer
    wideTablet?: Renderer
    tablet?: Renderer
    mobile?: Renderer
}

// Выбор содержимого в зависимости от размера экрана.
// Всегда выбирается один из вариантов, даже если не задан подходящий.
export function ResponsiveLayout(props: Props) {

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    let content
    switch (bootstrapSize) {
        case 'xxs':
        case 'xs':
        case 'sm':
            content = render(props.mobile, [props.tablet, props.wideTablet, props.desktop])
            break
        case 'md':
            content = render(props.tablet, [props.wideTablet, props.desktop])
            break
        case 'lg':
            content = render(props.wideTablet, [props.desktop])
            break
        case 'xl':
        case 'xxl':
        default:
            content = render(props.desktop)
            break
    }

    return (
        <>{content}</>
    )
}

// Обработка рендерера или выбор запасного варианта из предоставленных.
function render(
    renderer?: Renderer,
    fallbacks: (Renderer | undefined)[] = []
): ReactNode | null {
    if (renderer !== undefined) {
        return typeof renderer === 'function' ? renderer() : renderer
    } else {
        for (const item of fallbacks) {
            if (item) {
                const fallback: Renderer = item
                return typeof fallback === 'function' ? fallback() : fallback
            }
        }
    }
    return null
}
